import { HeaderAccountantMenu } from '@/_metronic/partials/layout/header-menus/HeaderAccountantMenu';
import { HeaderCommunityMenu } from '@/_metronic/partials/layout/header-menus/HeaderCommunityMenu';
import { HeaderSystemUserMenu } from '@/_metronic/partials/layout/header-menus/HeaderSystemUserMenu';
import { type HeaderUserMenuProps } from '@/_metronic/partials/layout/header-menus/_types';
import { ContactType } from '@/app/models/Contact';
import { type FC } from 'react';

export const USER_MENU_BY_USER_TYPE: Partial<Record<ContactType, FC<HeaderUserMenuProps>>> = {
  [ContactType.COMMUNITY]: HeaderCommunityMenu,
  [ContactType.ACCOUNTANT]: HeaderAccountantMenu,
  [ContactType.ADMIN]: HeaderSystemUserMenu,
  [ContactType.SYSTEM_USER]: HeaderSystemUserMenu,
};
